import styled from 'styled-components';
import { Button, Icon } from '@hiiretail/synergy-ui';

export const StyledButton = styled(Button)`
  background: none;
  padding: 0;
  
  :disabled {
    background-color: #EEEEEE;
  }
  
  :hover {
    background-color: #EEEEEE;
  }
  
  :active {
    background-color: #DFE3E8;
  }
`;

export const StyledPlusIcon = styled(Icon.Plus)`
  display: flex;
`;
